import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { injectIntl } from 'react-intl';

import messages from './ArticlePrintings.intl';

import styles from './ArticlePrintings.module.scss';
import { KENTICO_TYPES } from '../../../../consts/kentico';

@injectIntl
export default class ArticlePrintings extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  renderLink(link, isArticleFromPressRoom) {
    return (
      <div
        key={link.name}
        className={
          isArticleFromPressRoom
            ? `${styles.ArticlePrintingsItem} ${styles.pressRoomArticleItem}`
            : styles.ArticlePrintingsItem
        }
      >
        {link.value.map(
          item =>
            isArticleFromPressRoom ? (
              <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                {link.name.replace(/_|-/g, ' ')}
              </a>
            ) : (
              <div key={item.name} className={styles.generalMeetingLinks}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  {item.name.replace(/_|-/g, ' ')}
                </a>
              </div>
            )
        )}
      </div>
    );
  }

  render() {
    const {
      className,
      formatTXT,
      formatDOC,
      formatPDF,
      formatIMG,
      type
    } = this.props;
    const formats = [
      {
        name: 'TXT',
        value: formatTXT
      },
      {
        name: 'DOC',
        value: formatDOC
      },
      {
        name: 'PDF',
        value: formatPDF
      },
      {
        name: 'IMG',
        value: formatIMG.value
      }
    ];
    const isArticleFromPressRoom = type === KENTICO_TYPES.PRESS_ROOM_NEWS;

    const formatsList = formats.map((item, i) => {
      if (item.value && item.value.length !== 0) {
        return this.renderLink(item, isArticleFromPressRoom);
      }
      return null;
    });

    return (
      <div className={` ${styles.ArticlePrintings} ${className} `}>
        <span className={styles.SpanPrintOrDownload}>
          {this.props.intl.formatMessage(messages.downloadInVersion)}
        </span>
        <div className={styles.Formats}>{formatsList}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/ArticlePrintings/ArticlePrintings.js